import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import '../styles/RankingModal.css';

const RankingModal = ({ rankingItem, isOpen, onClose }) => {
  // ESCキーでモーダルを閉じる
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'hidden'; // スクロールを無効化
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'unset'; // スクロールを復元
    };
  }, [isOpen, onClose]);

  // モーダルが閉じている場合は何も表示しない
  if (!isOpen || !rankingItem) return null;

  // 背景クリックでモーダルを閉じる
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // 視聴ボタンのクリック
  const handleWatchClick = () => {
    if (rankingItem.videoUrl) {
      window.open(rankingItem.videoUrl, '_blank');
    }
  };
  
  // プラットフォームに応じたボタンテキストとスタイルを取得
  const getPlatformInfo = () => {
    if (rankingItem.serviceKind === 'twitcasting') {
      return {
        text: 'ツイキャスで視聴',
        className: 'watch-button twitcasting',
        icon: '▶'
      };
    }
    return {
      text: 'YouTubeで視聴',
      className: 'watch-button',
      icon: '▶'
    };
  };
  
  const platformInfo = getPlatformInfo();

  // 数値フォーマット関数（ハイフン対応）
  const formatNumber = (num) => {
    if (num === null || num === undefined) return '0';
    if (num === '-' || num === '－') return '-';
    if (typeof num === 'string') return num;
    return num.toLocaleString('ja-JP');
  };

  // 日時フォーマット関数
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  };


  return ReactDOM.createPortal(
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="ranking-modal-content">
        {/* 閉じるボタン（stickyで右上に固定） */}
        <div className="modal-actions">
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        {/* ヘッダー */}
        <div className="modal-header">
          <div className="modal-datetime">
            ランキング #{rankingItem.rank}位
          </div>
        </div>

        {/* メイン画像 */}
        <div className="modal-image" onClick={handleWatchClick} style={{cursor: 'pointer'}}>
          <div className="modal-image-bg">
            <img src={rankingItem.videoThumbnail || rankingItem.channelThumbnail} alt="" />
          </div>
          <img src={rankingItem.videoThumbnail || rankingItem.channelThumbnail} alt={rankingItem.streamTitle} />
        </div>

        {/* 配信情報 */}
        <div className="modal-info">
          <div className="modal-title-overlay">
            <h2>{rankingItem.streamTitle}</h2>
          </div>
          <div className="streamer-info">
            {rankingItem.channelUrl ? (
              <a 
                href={rankingItem.channelUrl} 
                target="_blank" 
                rel="noopener" 
                className="streamer-header"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {rankingItem.channelThumbnail && (
                  <div className="streamer-avatar">
                    <img src={rankingItem.channelThumbnail} alt={rankingItem.channelName} />
                  </div>
                )}
                <h3 className="streamer-name">{rankingItem.channelName}</h3>
              </a>
            ) : (
              <div className="streamer-header">
                {rankingItem.channelThumbnail && (
                  <div className="streamer-avatar">
                    <img src={rankingItem.channelThumbnail} alt={rankingItem.channelName} />
                  </div>
                )}
                <h3 className="streamer-name">{rankingItem.channelName}</h3>
              </div>
            )}
            <div className="stream-description">
              <p><strong>ランキング:</strong> #{rankingItem.rank}位</p>
              <p><strong>{rankingItem.maxConcurrent ? '最大同接数' : (rankingItem.serviceKind === 'twitcasting' ? '総視聴者数' : '総再生数')}:</strong> {formatNumber(rankingItem.maxConcurrent || rankingItem.totalViews)}</p>
              <p><strong>配信時間:</strong> {rankingItem.duration}</p>
              {rankingItem.streamDate && (
                <p><strong>配信日時:</strong> {formatDate(rankingItem.streamDate)}</p>
              )}
              {rankingItem.description && (
                <div style={{marginTop: '10px'}}>
                  {rankingItem.description
                    .replace(/\\n/g, '\n')  // エスケープされた\\nを実際の改行に変換
                    .split('\n')
                    .map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* 固定ボタンエリア */}
      <div className="modal-button-area">
        <button className={platformInfo.className} onClick={handleWatchClick}>
          <span className="platform-icon">{platformInfo.icon}</span>
          {platformInfo.text}
        </button>
      </div>

    </div>,
    document.body
  );
};

export default RankingModal;
